import { render, staticRenderFns } from "./queCar.vue?vue&type=template&id=2ad72240&scoped=true"
import script from "./queCar.vue?vue&type=script&lang=js"
export * from "./queCar.vue?vue&type=script&lang=js"
import style0 from "./queCar.vue?vue&type=style&index=0&id=2ad72240&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad72240",
  null
  
)

export default component.exports